<template>
    <div>
        <CCol sm="12" class="bg-FAFAFA">
    
    
            <CCol sm="12" style="width: 100%;background-size: cover; margin: auto;color: #fff">
                <CRow class="p-2">
                    <CCol sm="9">
                        <CRow>
                            <CCol sm="12" md="4" lg="4" class="p-1">
                                <div class="custom-bg-gradient-red" style="width: 100%;color: #fff">
                                    <h3 class="custom-18px-600 text-white">
                                        Total Applied
                                    </h3>
                                    <p class="custom-32px-700 text-white">0</p>
                                </div>
                            </CCol>
                            <CCol sm="12" md="4" lg="4" class="p-1">
                                <div class="custom-bg-gradient-blue-white" style="width: 100%;color: #fff">
                                    <h3 class="custom-18px-600 text-white">
                                        Hours Taken
                                    </h3>
                                    <p class="custom-32px-700 text-white">0</p>
                                </div>
                            </CCol>
                            <CCol sm="12" md="4" lg="4" class="p-1">
                                <div class="custom-bg-gradient-white-blue" style="width: 100%;color: #fff">
                                    <h3 class="custom-18px-600 text-white">
                                        Hours Taken Month
                                    </h3>
                                    <p class="custom-32px-700 text-white">0</p>
                                </div>
                            </CCol>
                        </CRow>
                        <CRow class="mt-2">
                            <div>
                <CCol sm="12" md="4" lg="3" style="float:right">
                            <div>


    </div>
</CCol>
      
            </div>
                        </CRow>
                        <v-client-table :data="timeoffTableData" :columns="columns" :options="options" class="custom-table"  v-if="timeoffTableData.length > 0">
<template v-slot:index="{ row }">
    <label class="custom-12px-500">{{ row.Index }}</label>
</template>

<template v-slot:Status="{ row }">
    <label class="custom-12px-500 bg-F2F4F7">{{ row.Status }}</label>
</template>

<template v-slot:Action="{ row }">
    <div class="d-flex">
    <img :src="require('@/assets/img/printer.png')" alt="Print" style="cursor: pointer;width:30px" @click="printRow(row.Index)" />
    <img :src="require('@/assets/img/view.png')" alt="View" style="cursor: pointer;width:30px" @click="viewRow(row.Index)" class="ml-2" />
</div>
</template>
              </v-client-table>
              <div v-else class="no-data-message text-center" style="margin:15%">
      <img src="../assets/img/NODATA.png" alt="No Data" style="max-width:100px;"/>
      <p class="custom-16px-600 font-inter font-color-0B63F6 m-0">No Data Available</p>
      <p class="custom-14px-400 font-inter font-color-171717">Your search “Landing page design” did not <br /> match any projects. Please try again.</p>
    </div> 
             
                    </CCol>
                    <CCol sm="3">
                        <div class="custom-input-app-form text-center p-2">
    
                            <CCol sm="12" class="text-left">
                                <h3 class="custom-18px-500 font-inter font-color-171717">Apply Timeoff</h3>
                               
                                <CRow class="mt-3">
                                    <CCol sm="12">
                                        <label class="font-color-171717 font-inter custom-14px-500">Timeoff Date</label>
                                    </CCol>
                                    <CCol sm="12">
                                        <CInput type="text" />
                                    </CCol>
                                </CRow>
    
                                <CRow class="mt-2">
                                    <CCol sm="12">
                                        <label class="font-color-171717 font-inter custom-14px-500">Set Date </label>
                                    </CCol>
                                    <CCol sm="12">
                                        <CInput type="text" />
                                    </CCol>
                                </CRow>

                                <CRow class="mt-2">
                                    <CCol sm="12">
                                        <label class="font-color-171717 font-inter custom-14px-500">Total Hours</label>
                                    </CCol>
                                    <CCol sm="12">
                                        <CInput type="text" disabled/>
                                    </CCol>
                                </CRow>
    
                                <CRow class="mt-2">
                                    <CCol sm="12">
                                        <label class="font-color-171717 font-inter custom-14px-500">What is/are your reason to apply timeoff?</label>
                                        <CTextarea rows="4" placeholder="Please specify your reason..."></CTextarea>
                                    </CCol>
                                </CRow>
    
                                <CRow class="mt-3">
                                    <CCol sm="12">
                                        <label class="font-color-171717 font-inter custom-14px-500">Additional Description</label>
                                        <CTextarea rows="4" placeholder="Please specify your reason..."></CTextarea>
                                    </CCol>
                                </CRow>
                            </CCol>
    
    
                        </div>
                    </CCol>
    
                </CRow>
    
    
            </CCol>
    
        </CCol>
    
    </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);
import _ from "lodash";


import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import VueCal from 'vue-cal';
import 'vue-cal/dist/vuecal.css';


export default {

    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        VueCal

    },

    data() {
        return {
            leaveOptions: [{
                    id: 1,
                    name: 'Annual Leave'
                },
                {
                    id: 2,
                    name: 'Emergency Leave'
                },
                {
                    id: 3,
                    name: 'Maternity Leave'
                },
                {
                    id: 3,
                    name: 'Paternity Leave'
                },
            ],
            "events": [{
                    "id": 1,
                    "start": "2024-08-10T10:00:00",
                    "end": "2024-08-10T11:00:00",
                    "title": "Event Title",
                    "description": "Event Description"
                },
                // More events
            ],
            startDate: new Date(),
            defaultView: 'month', // Default view to month
            timeoffTableData: []

        }





    },
    async mounted() {
        this.$nextTick(() => {
      this.setCalendarView();
    });
        // try {
        //     const isAuth = await this.UserAuth();
        //     if (isAuth) {

        //     } else {
        //         this.GoToPage();
               
        //     }
        // } catch (error) {
        //     this.GoToPage();
        //     console.error("Error during authentication:", error);
        //     // Handle the error here
        // }

    },

    computed: {

    },
    created() {
    this.setDefaultMonth();
  },
    methods: {
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.user = response.data;
                    console.log("userInfo", this.user);
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        GoToPage() {
            let path = this.$router.currentRoute.path;
            if (path.toLowerCase() != "/Login") {

                this.$router.push({
                    path: '/Login',
                    query: {
                        targetUrl: this.$router.currentRoute.fullPath,
                    }
                })

            }
        },
       
        onDayClick(date) {
      console.log('Date clicked:', date);
      // Handle day click event
    },
    setCalendarView() {
      const vueCal = this.$refs.vueCal;
      if (vueCal) {
        vueCal.setView(this.defaultView); // Set the calendar view to month
      }
    }


    }

};
</script>